import { useLazyQuery } from '@apollo/client';
import { getServiceRequestFeaturesByChanneld } from 'lane-shared/graphql/workOrders';
import { useCallback } from 'react';

export const useCanCreateServiceRequestForChannel = () => {
  const [executeQuery] = useLazyQuery(getServiceRequestFeaturesByChanneld, {
    fetchPolicy: 'network-only',
  });

  const checkCanCreateServiceRequest = useCallback(
    async (channelId: string): Promise<boolean> => {
      try {
        const { data } = await executeQuery({ variables: { channelId } });

        return (
          data?.getServiceRequestFeaturesByChannelId?.features
            ?.createServiceRequest ?? false
        );
      } catch {
        return false;
      }
    },
    [executeQuery]
  );

  return { checkCanCreateServiceRequest };
};
